import './index.css';
import App from './App';
import React from 'react';
import {Provider} from 'react-redux';
import ReactDOM from 'react-dom/client';
import {store} from './Redux/CreateStore';
import reportWebVitals from './reportWebVitals';
import Progress from './Progress';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';

Progress.init({
  color: '#e1f4fb',
  showSpinner: true
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  
    <Provider store={store}>
      <App />
    </Provider>
  
);
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
